import React from 'react';
import _ from 'lodash';

import DropdownDisplay from '../dropdown-display.jsx';
import DropdownList from '../dropdown-list.jsx';
import Option from '../option';

export default function LabelDropdown(props) {
  const generateOptionList = (optionList) => {
    if (_.isEmpty(optionList)) {
      return null;
    }

    return _.map(optionList, (option, index) => {
      const className = option.className || '';

      return (
        <Option
          className={className}
          onClick={props.changeHandler}
          style={option.style}
          value={option.value}
          selected={props.value === option.value || option.selected}
          key={index}
        >
          {option.label}
        </Option>
      );
    });
  };

  const selectedOption = props.options.find(option => option.value === props.value);
  const label = props.label || (selectedOption || {}).label || '';

  return (
    <div>
      <DropdownDisplay clickHandler={props.toggleDropdown}>
        <span style={props.selectedLabelStyle}>{label}</span>
      </DropdownDisplay>

      <DropdownList open={props.open}>{generateOptionList(props.options)}</DropdownList>
    </div>
  );
}

LabelDropdown.propTypes = {
  open: React.PropTypes.bool,
  toggleDropdown: React.PropTypes.func,
  label: React.PropTypes.string,
  value: React.PropTypes.string,
  selectedLabelStyle: React.PropTypes.object,
  options: React.PropTypes.array,
  changeHandler: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-types/label-dropdown.jsx